import {useAuth} from 'context/authContext';
import {useMutation} from 'react-query';
import {useNavigate} from 'react-router-dom';
import {sendConfirmation} from 'services/auth';
import normalizeLoginResponse from 'utilities/helper/normalizeLoginResponse/normalizeLoginResponse';

const UseSendConfirmation = () => {
  const navigate = useNavigate();
  const {login} = useAuth();
  const {isLoading, mutate} = useMutation({
    mutationFn: (payload: ISendConfirmationCodePayload) => {
      return sendConfirmation(payload);
    },
    onSuccess: (data, variables) => {
      if (!data?.is_registered) {
        navigate('/auth/signUp', {
          state: {
            mobile: variables?.mobile,
            code: variables?.otp_code,
          },
        });
        return;
      }
      login(normalizeLoginResponse(data, 'market')!);
      navigate('/wholesaler/home');
    },
  });

  return {isLoading, mutate};
};

export default UseSendConfirmation;
